import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

export default class extends ApplicationController {
  static targets = [
    "modeSelect",
    "modeSensitiveField", // masqué uniquement en mode "svg" (tip/title/body/tabsection)
    "svgOnlyField",       // visible UNIQUEMENT en mode "svg" (svg_content_fr/en)
    "modalOnlyField",     // visible UNIQUEMENT en mode "modal" (section Modal HTML)
  ];

  connect() {
    console.log("FxFeatureTour JS en cours ...");
    super.connect();
    if ($("#search").length && $("#quick_sort").length) {
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      this.handleSidebarScroll("fx_feature_tour_");
    }

    requestAnimationFrame(() => this.toggleModeFields());
  }

  toggleModeFields() {
    if (!this.hasModeSelectTarget) return;
    const mode = this.modeSelectTarget.value; // "spotlight" | "modal" | "svg"
    const isSvg = mode === "svg";
    const isModal = mode === "modal";

    // Champs communs (tip/title/body/tabsection) : masqués seulement en mode svg
    this.modeSensitiveFieldTargets.forEach((el) => this._toggleField(el, isSvg));

    // Champs SVG : visibles uniquement en mode svg
    this.svgOnlyFieldTargets.forEach((el) => this._toggleField(el, !isSvg));

    // Section "Modal (HTML)" : visible uniquement en mode modal
    this.modalOnlyFieldTargets.forEach((el) => this._toggleField(el, !isModal));
  }

  _toggleField(el, hide) {
    el.style.display = hide ? "none" : "";
    el.querySelectorAll("input, textarea, select").forEach((input) => {
      if (hide) {
        input.dataset.wasRequired = input.required ? "1" : "0";
        input.required = false;
      } else {
        input.required = input.dataset.wasRequired === "1";
      }
    });
  }

  get current_app() {
    return this.data.get("app");
  }
  get params() {
    return this.data.get("params");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}